<div class="simple-tracker-container">
  <mat-expansion-panel class="{{ matElevationClass }}" (opened)="handleOpened()" (closed)="handleClosed()">
    <mat-expansion-panel-header>
      <div class="header-container" [ngClass]="{ 'no-badge': !projectStatus }">
        <div class="project-title">{{ projectTitle }}</div>
        <div *ngIf="projectStatus" class="badge">
          <glxy-badge [color]="badgeColor" class="status-badge">
            {{ projectStatus }}
          </glxy-badge>
        </div>
        <div class="project-progress">
          {{ 'PROJECT_TRACKER.TASKS_COMPLETED' | translate : { numberTasks: projectProgress } }}
        </div>
      </div>
    </mat-expansion-panel-header>

    <div *ngIf="!hideAskQuestion" class="ask-question-container" (click)="handleAskQuestionClicked()">
      <div class="ask-question-text">
        <mat-icon>chat_bubble_outline</mat-icon>
        <span>{{ 'PROJECT_TRACKER.ASK_A_QUESTION' | translate }}</span>
      </div>
    </div>

    <project-tracker-subtasks
      [subtasks]="subtasks"
      (approveClicked)="handleApproveClicked()"
      (provideFeedbackClicked)="handleProvideFeedbackClicked()"
      (sendFeedbackClicked)="handleSendFeedbackClicked()"
      (nonClickableClicked)="handleNonClickableClicked($event)"
    ></project-tracker-subtasks>
  </mat-expansion-panel>
</div>
